<div class="table-container">
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>
      <!-- Dynamic Columns -->
      <ng-container *ngFor="let column of columns" [matColumnDef]="column.key">
        <th
          mat-header-cell
          *matHeaderCellDef
          [mat-sort-header]="column.sortable ? column.key : null"
        >
          <div class="cell-content">
            {{ column.label }}
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          (click)="onColumnClick(column, row, $event)"
          [class.clickable]="column.clickable"
        >
          <div class="cell-content">
            <ng-container *ngIf="hasColumnIcon(column) && column.icon">
              <mat-icon class="column-icon">{{ column.icon }}</mat-icon>
            </ng-container>
            <span>{{ row[column.key] }}</span>
          </div>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container
        matColumnDef="actions"
        *ngIf="actions && actions.length > 0"
      >
        <th mat-header-cell *matHeaderCellDef>
          <div class="cell-content">
            {{ actionColName || '' }}
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="action-buttons">
            <button
              mat-icon-button
              *ngFor="let action of actions"
              [color]="action.color"
              [matTooltip]="action.tooltip"
              (click)="onActionClick($event, action, row)"
            >
              <mat-icon>{{ action.icon }}</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <!-- pagination -->
  <ng-container>
    <div class="row mt-3 mx-1" *ngIf="data && data.length > 0">
      <!-- Begin:: Number of Results Selector -->
      <div class="col" style="width: 25%">
        <mat-select
          class="bottom-panel__results-drop-down"
          [(ngModel)]="pageSize"
          (selectionChange)="onChangePageSize($event)"
        >
          <mat-option *ngFor="let step of pageSizeOptions" [value]="step"
            >{{ step }} results</mat-option
          >
        </mat-select>
      </div>
      <!-- End:: Number of Results Selector -->

      <!-- Begin:: Show More Button -->
      <div class="col show-more">
        <button
          class="bottom-panel__show-more-button"
          mat-button
          (click)="onTriggerShowMore()"
          data-testid="dlt_btn_show_more"
        >
          <!-- <mat-icon> <mat-spinner diameter="20"> </mat-spinner> </mat-icon> -->
          Show
          {{ pageSize }} More
        </button>
      </div>
      <!-- End:: Show More Button -->
    </div>
  </ng-container>
</div>
